import { render, staticRenderFns } from "./corps.vue?vue&type=template&id=6f04af98&"
import script from "./corps.vue?vue&type=script&lang=js&"
export * from "./corps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports